module.exports = __webpack_public_path__ + "static/media/question-mark.1ae4d9f4.svg";